<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.71,7.29C15.71,7.29,13.71,5.29,13.71,5.29C13.53,5.11,13.28,5,13,5C12.45,5,12,5.45,12,6C12,6.28,12.11,6.53,12.29,6.71C12.29,6.71,12.59,7,12.59,7C12.59,7,9,7,9,7C9,7,9,3.41,9,3.41C9,3.41,9.29,3.7,9.29,3.7C9.47,3.89,9.72,4,10,4C10.55,4,11,3.55,11,3C11,2.72,10.89,2.47,10.71,2.29C10.71,2.29,8.71,0.29,8.71,0.29C8.53,0.11,8.28,0,8,0C7.72,0,7.47,0.11,7.29,0.29C7.29,0.29,5.29,2.29,5.29,2.29C5.11,2.47,5,2.72,5,3C5,3.55,5.45,4,6,4C6.28,4,6.53,3.89,6.71,3.71C6.71,3.71,7,3.41,7,3.41C7,3.41,7,7,7,7C7,7,3.41,7,3.41,7C3.41,7,3.7,6.71,3.7,6.71C3.89,6.53,4,6.28,4,6C4,5.45,3.55,5,3,5C2.72,5,2.47,5.11,2.29,5.29C2.29,5.29,0.29,7.29,0.29,7.29C0.11,7.47,0,7.72,0,8C0,8.28,0.11,8.53,0.29,8.71C0.29,8.71,2.29,10.71,2.29,10.71C2.47,10.89,2.72,11,3,11C3.55,11,4,10.55,4,10C4,9.72,3.89,9.47,3.71,9.29C3.71,9.29,3.41,9,3.41,9C3.41,9,7,9,7,9C7,9,7,12.59,7,12.59C7,12.59,6.71,12.3,6.71,12.3C6.53,12.11,6.28,12,6,12C5.45,12,5,12.45,5,13C5,13.28,5.11,13.53,5.29,13.71C5.29,13.71,7.29,15.71,7.29,15.71C7.47,15.89,7.72,16,8,16C8.28,16,8.53,15.89,8.71,15.71C8.71,15.71,10.71,13.71,10.71,13.71C10.89,13.53,11,13.28,11,13C11,12.45,10.55,12,10,12C9.72,12,9.47,12.11,9.29,12.29C9.29,12.29,9,12.59,9,12.59C9,12.59,9,9,9,9C9,9,12.59,9,12.59,9C12.59,9,12.3,9.29,12.3,9.29C12.11,9.47,12,9.72,12,10C12,10.55,12.45,11,13,11C13.28,11,13.53,10.89,13.71,10.71C13.71,10.71,15.71,8.71,15.71,8.71C15.89,8.53,16,8.28,16,8C16,7.72,15.89,7.47,15.71,7.29C15.71,7.29,15.71,7.29,15.71,7.29Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Move',
} as DefineComponent
</script>
